var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import Title from './Title';
import { Button, InputAdornment, Typography } from '@material-ui/core';
import useFocusOptions from './useFocusOptions';
import Select from '../Select';
import { extractMultipleValue, getValue } from './utils';
import useDimensionOptions from './useDimensionOptions';
import InputProxy from './InputProxy';
import Proxy from './Proxy';
import useAxisOptions from './useAxisOptions';
import { makeStyles } from '@material-ui/core/styles';
import DataEdit from '../DataEdit';
export var useStyles = makeStyles(function (theme) {
  return {
    greyVariant: {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.grey[600]
    }
  };
});
var ChartConfig = function ChartConfig(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === undefined ? {} : _ref$labels,
    _ref$properties = _ref.properties,
    properties = _ref$properties === undefined ? {} : _ref$properties;
  var classes = useStyles();
  var _useDimensionOptions = useDimensionOptions(properties),
    dimensions = _useDimensionOptions[0];
  var xKeys = useAxisOptions(properties, 'X');
  var yKeys = useAxisOptions(properties, 'Y');
  var highlight = properties.highlight,
    baseline = properties.baseline;
  var _useFocusOptions = useFocusOptions(highlight, labels),
    highlightOptions = _useFocusOptions[0],
    xhighlightOptions = _useFocusOptions[1];
  var _useFocusOptions2 = useFocusOptions(baseline, labels),
    baselineOptions = _useFocusOptions2[0],
    xbaselineOptions = _useFocusOptions2[1];
  var _properties$stackedMo = properties.stackedMode,
    stackedMode = _properties$stackedMo === undefined ? {} : _properties$stackedMo;
  var _stackedMode$options = stackedMode.options,
    stackedModeOptions = _stackedMode$options === undefined ? [] : _stackedMode$options;
  var _properties$displayMo = properties.displayMode,
    displayMode = _properties$displayMo === undefined ? {} : _properties$displayMo;
  var _displayMode$options = displayMode.options,
    displayModeOptions = _displayMode$options === undefined ? [] : _displayMode$options;
  var dKeys = ['dimensions', 'stackedDimension', 'scatterDimension', 'symbolDimension'];
  var eKeys = ['title', 'subtitle', 'source', 'logo', 'copyright'];
  if (R.isEmpty(properties)) return null;
  return React.createElement(Grid, {
    container: true,
    spacing: 3,
    'data-testid': 'charts-config-test-id'
  }, React.createElement(Proxy, {
    keys: dKeys,
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.series
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, React.createElement(Proxy, {
    keys: ['stackedMode'],
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 1,
    alignItems: 'center',
    style: {
      minWidth: 320
    }
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    variant: 'body2'
  }, labels.stackedMode)), R.map(function (option) {
    return React.createElement(Grid, {
      item: true,
      key: option.value
    }, React.createElement(Button, {
      variant: option.value === stackedMode.value ? 'contained' : 'outlined',
      onClick: function onClick() {
        return stackedMode.onChange(option.value);
      },
      color: 'primary'
    }, React.createElement(Typography, {
      variant: 'body2'
    }, R.path(['stackedModeOptions', option.value], labels))));
  }, stackedModeOptions))), R.map(function (_ref2) {
    var key = _ref2[0],
      dimension = _ref2[1];
    return React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        minWidth: 320
      },
      key: key
    }, React.createElement(Select, _extends({}, dimension, {
      onChange: dimension.onChange,
      label: R.prop(key, labels),
      value: getValue(dimension.value),
      items: dimension.options
    })));
  }, dimensions)))))), React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, React.createElement(Proxy, {
    keys: ['highlight', 'baseline'],
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 8,
    container: true,
    alignContent: 'flex-start'
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.focus
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 320
    }
  }, React.createElement(Select, _extends({}, highlight, {
    onChange: function onChange(ids) {
      return highlight.onChange(R.props(ids, xhighlightOptions));
    },
    value: extractMultipleValue(highlight),
    items: highlightOptions,
    isMultiple: true,
    isClearable: true,
    label: R.prop('highlight', labels),
    placeholder: R.prop('select', labels),
    optionsKey: 'highlight'
  }))), React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minWidth: 320
    }
  }, React.createElement(Select, _extends({}, baseline, {
    onChange: function onChange(id) {
      return baseline.onChange(R.pipe(R.props([id]), R.without(baseline.value))(xbaselineOptions));
    },
    value: R.pipe(R.propOr([], 'value'), R.head, R.prop('value'))(baseline),
    items: baselineOptions,
    isClearable: true,
    label: R.prop('baseline', labels),
    placeholder: R.prop('select', labels),
    optionsKey: 'baseline'
  }))))))), React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 4,
    container: true,
    alignContent: 'flex-start'
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.size
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, React.createElement(InputProxy, {
    pkey: 'width',
    labels: labels,
    properties: properties,
    InputProps: {
      endAdornment: React.createElement(InputAdornment, {
        position: 'end'
      }, 'px')
    }
  }), React.createElement(InputProxy, {
    pkey: 'height',
    labels: labels,
    properties: properties,
    InputProps: {
      endAdornment: React.createElement(InputAdornment, {
        position: 'end'
      }, 'px')
    }
  }))))), React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, React.createElement(Proxy, {
    keys: xKeys,
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    className: classes.greyVariant
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.axisX,
    icon: React.createElement(ArrowForwardIcon, null)
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, R.map(function (key) {
    return React.createElement(InputProxy, {
      pkey: key,
      mkey: R.init(key),
      key: key,
      lg: 12 / R.length(xKeys),
      labels: labels,
      properties: properties
    });
  }, xKeys))))), React.createElement(Proxy, {
    keys: ['freqStep'],
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    className: classes.greyVariant
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.axisX,
    icon: React.createElement(ArrowForwardIcon, null)
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, React.createElement(InputProxy, {
    pkey: 'freqStep',
    labels: labels,
    properties: properties
  }))))), React.createElement(Proxy, {
    keys: yKeys,
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    className: classes.greyVariant
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Title, {
    label: labels.axisY,
    icon: React.createElement(ArrowUpwardIcon, null)
  })), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, R.map(function (key) {
    return React.createElement(InputProxy, {
      pkey: key,
      mkey: R.init(key),
      key: key,
      lg: 12 / R.length(yKeys),
      labels: labels,
      properties: properties
    });
  }, yKeys)))))), React.createElement(Proxy, {
    keys: eKeys,
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true
  }, React.createElement(DataEdit, {
    labels: labels,
    properties: properties
  })))), React.createElement(Proxy, {
    keys: ['displayMode'],
    properties: properties
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true
  }, React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 1,
    alignItems: 'center',
    style: {
      minWidth: 320
    }
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    variant: 'body2'
  }, labels.display)), R.map(function (option) {
    return React.createElement(Grid, {
      item: true,
      key: option.value
    }, React.createElement(Button, {
      variant: option.value === displayMode.value ? 'contained' : 'outlined',
      onClick: function onClick() {
        return displayMode.onChange(option.value);
      },
      color: 'primary'
    }, React.createElement(Typography, {
      variant: 'body2'
    }, R.path(['displayOptions', option.value], labels))));
  }, displayModeOptions))))));
};
var submitableInputProptypes = PropTypes.shape({
  id: PropTypes.string,
  isActive: PropTypes.bool,
  onSubmit: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
var selectableInputProptypes = PropTypes.shape({
  id: PropTypes.string,
  isActive: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })
});
var multiSelectableInputProptypes = PropTypes.shape({
  id: PropTypes.string,
  isActive: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  value: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }))
});
ChartConfig.propTypes = process.env.NODE_ENV !== "production" ? {
  labels: PropTypes.object,
  properties: PropTypes.shape({
    highlight: multiSelectableInputProptypes,
    baseline: multiSelectableInputProptypes,
    width: submitableInputProptypes,
    height: submitableInputProptypes,
    scatterDimension: selectableInputProptypes,
    scatterX: selectableInputProptypes,
    scatterY: selectableInputProptypes,
    symbolDimension: selectableInputProptypes,
    stackedDimension: selectableInputProptypes,
    stackedMode: PropTypes.shape({
      id: PropTypes.string,
      isActive: PropTypes.bool,
      onChange: PropTypes.func,
      options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string
      })),
      value: PropTypes.string
    }),
    freqStep: submitableInputProptypes,
    maxX: submitableInputProptypes,
    minX: submitableInputProptypes,
    pivotX: submitableInputProptypes,
    stepX: submitableInputProptypes,
    maxY: submitableInputProptypes,
    minY: submitableInputProptypes,
    pivotY: submitableInputProptypes,
    stepY: submitableInputProptypes,
    title: submitableInputProptypes,
    subtitle: submitableInputProptypes,
    source: submitableInputProptypes
  })
} : {};
export default ChartConfig;